/* DeleteImageComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./DeleteImageRenderer");

class DeleteImageComponent extends EventEmitter {
    constructor(entity, platformName, logger) {
        super();
        this._entity = entity;
        this._platformName = platformName;
        this._logger = logger;
        this._titleText = "Remove Image";
        this._renderer = new Renderer(this);
        this._checkboxValue = false;

        this.reject = this.reject.bind(this);
        this.resolve = this.resolve.bind(this);

        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get titleText() {
        return this._titleText;
    }

    get entity() {
        return this._entity;
    }

    get platformName() {
        return this._platformName;
    }

    get logger() {
        return this._logger;
    }

    get checkboxValue() {
        return this._checkboxValue;
    }

    setCheckboxValue(value) {
        this._checkboxValue = value;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._renderer = undefined;
                this._entity = undefined;
                this._platformName = undefined;
                this._logger = undefined;
            },
            (err) => {
                if (this._logger) {
                    this._logger.warn({error: err}, "DeleteImageComponent.shutdown() error");
                }
            }
        );
    }

    cancelAction() {
        let err = new Error("user rejected");
        err.userRejected = true;
        return this.reject(err);
    }

    confirmAction() {
        return this.resolve({
            confirmed: true,
            checkboxValue: this._checkboxValue,
        });
    }

    reject(err) {
        this._context.reject(err);
    }

    resolve(action) {
        this._context.resolve(action);
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /*******************************************/
}

module.exports = DeleteImageComponent;
